import { Component, Injector, OnInit } from '@angular/core';

import { ModalBaseComponent } from '../base-modal/base-modal';

@Component({
  selector: 'hero-ok-cancel-dialog',
  templateUrl: './ok-cancel-dialog.component.html',
  styleUrls: ['./ok-cancel-dialog.component.scss'],
})
export class OkCancelDialogComponent extends ModalBaseComponent implements OnInit {
  toTranslate = [];
  header: string;
  optionalLabel: string;

  title: string;
  message: string;
  cancelText: string;
  okText: string;
  yesButtonClass: string;
  noButtonClass: string;
  showSuccessMessage = true;

  constructor(public injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initClasses();
  }

  onOk() {
    this.bitfDialogRef.close({ status: this.eBitfCloseEventStatus.OK });
  }

  onCancel() {
    this.bitfDialogRef.close({ status: this.eBitfCloseEventStatus.CANCEL });
  }

  initClasses() {
    this.yesButtonClass = 'btn btn-lg ' + (this.yesButtonClass || 'btn-primary');
    this.noButtonClass = 'btn btn-lg ' + (this.noButtonClass || 'btn-cancel');
  }
}
